import React from "react";


const RightArrow = () => {
      const handleScrollNext = () => {
      const container = document.querySelector('.react-horizontal-scrolling-menu--scroll-container');
      container.scrollBy({ left: 400, behavior: 'smooth' }); 
    };
    return (
      <button
        onClick={handleScrollNext}
        className="right btn  rounded-circle"
      >
       <i className="bi bi-arrow-right  fs-3"></i>
      </button>
    );
  };
  

  export default RightArrow;